export default __webpack_public_path__ + "static/media/dinheiro.eb275299.png";